import { Container, Box } from "@mui/material";
import React, { useState } from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
//import UploadDocument from '../components/common/UploadDocument';
import Input from "../components/Base/Input";
import Note from "../components/common/Note";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
export default function UploadIncomeTax() {
  const navigate = useNavigate();
  let location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(false);
  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const reqData = {
        formfiles: (() => {
          let data;
          for (const key of Object.keys(files)) data = files[key];
          return data;
        })(),
        filetype: "ITR",
        aid: location.state.AppId,
      };
      let resp = await apis.postWithFilesApi(
        configData.API_URL + "ApplicationFlow/UploadITR",
        reqData
      );
      let result = await resp.json();
      if (resp.status === 200) {
        if (result === "OK") {
          let data = { AppId: location.state.AppId };
          navigate("/loading", { state: data });
        } else {
          navigate("/error", {
            state: { AppId: location.state.AppId, H: "Error", Disc: "Error" },
          });
        }
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //console.log(err);
    }
  };
  const savefile = (e) => {
    if (e.target.files?.length > 0) {
      setFiles(e.target.files);
      setDisabled(false);
    } else {
      setFiles(undefined);
      setDisabled(true);
    }
    //console.log(e.target.files[0]);
    // setFiles(e.target.files);

    // setDisabled(false);
  };
  return (
    <>
      <Container maxWidth={false} sx={{ maxWidth: "425px" }}>
        <Header showBar={true} step={8} />
        <IntroCard
          title="Income Tax Return"
          subtitle="Upload the Income Tax return for last financial year."
          img="/assets/doc.svg"
        />
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "" }}>
            <Input
              type="file"
              multiple
              autoComplete="off"
              onChange={savefile}
              name="ITR"
              id="ITRId"
              accept=".zip,application/pdf"
            />
          </Box>
          <Note note="Only files with .pdf or .zip extension allowed" />
          {/*<UploadDocument*/}
          {/*  name="incomeTaxReturns"*/}
          {/*  UploadedIcon="/assets/uploadCertificate.png"*/}
          {/*  uploadTitle="Income Tax "*/}
          {/*  uploadIcon="/assets/uploadCertificate.png"*/}
          {/*/>*/}
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          <SubmitButton hasNote="No" disabled={disabled} />
        </form>
      </Container>
    </>
  );
}
